import { AddEditStateLevelTnc, CustomTemplate, Predefined, StateLevelTnc, Templates } from "@/pages";
import { routes } from "../utils";

export const TemplatesRoutes = () => {
  return {
    path: routes.templates,
    children: [
      {
        path: "",
        element: <Templates />,
      },
      {
        path: routes.predefinedTemplate,
        element: <Predefined />
      },
      {
        path: routes.customTemplate,
        children: [
          {
            path: "",
            element: <CustomTemplate />,
          },
          {
            path: routes.stateLevelTnc,
            children: [
              {
                path: "",
                element: <StateLevelTnc />
              },
              {
                path: routes.add,
                element: <AddEditStateLevelTnc />
              },
              {
                path: routes.id + "/" + routes.action,
                element: <AddEditStateLevelTnc />
              }
            ]
          }
        ]
      }
    ],
  };
};
